/* AuditSummaryViewRenderer.js */

"use strict";
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
// const Registrations = require("../../../../../RegistrationNamespaces");
const _ = require("lodash");
class AuditSummaryViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("audity-summary-view-gl");
        this._rootElem.component = this._model;
        this._footerEl = document.createElement("div");
        this._footerEl.classList.add("summary-grid-footer");
        this._logger = this._model.logger;

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Run All",
            name: "runAll",
            handler: (this._onRunAll = this._onRunAll.bind(this))
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "downloadSummary",
            handler: (this._onDownloadSummary = this._onDownloadSummary.bind(this))
        });
        this._viewActionsAdded = false;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model._pagingFeed.on("RefreshView", (this._onFeedRefreshView = this._onFeedRefreshView.bind(this)));
        this._model._deviceEntity.on("PropertiesUpdated", (this._renderFooter = this._renderFooter.bind(this)));
        // this._model.on("RefreshTotals", this._onRefreshTotals = this._onRefreshTotals.bind(this));
        this._registerGridListeners();
    }

    _registerGridListeners() {
        this._grid.on("UserSorted", (this._onUserSorted = this._onUserSorted.bind(this)));
        // this._grid.on(
        //     "UserRowDoubleClicked",
        //     (this._openAdvisoryView = this._openAdvisoryView.bind(this))
        // );
        this._grid.on("GridResized", (this._onGridWidthChange = this._onGridWidthChange.bind(this)));
        this._grid.on("GridBusyEnd", (this._onGridWidthChange = this._onGridWidthChange.bind(this)));
        this._grid.on("ColumnUserResized", (this._onGridWidthChange = this._onGridWidthChange.bind(this)));
    }

    _unregisterListeners() {
        if (!_.isUndefined(this._model._pagingFeed)) {
            this._model._pagingFeed.removeListener("RefreshView", this._onFeedRefreshView);
        }
        this._model._deviceEntity.removeListener("PropertiesUpdated", this._renderFooter);
        // this._model.removeListener("RefreshTotals", this._onRefreshTotals);
        this._unregisterGridListeners();
    }

    _unregisterGridListeners() {
        if (!_.isUndefined(this._grid)) {
            this._grid.removeListener("UserSorted", this._onUserSorted);
            // this._grid.removeListener("UserRowDoubleClicked", this._openAdvisoryView);
            this._grid.removeListener("GridResized", this._onGridWidthChange);
            this._grid.removeListener("GridBusyEnd", this._onGridWidthChange);
            this._grid.removeListener("ColumnUserResized", this._onGridWidthChange);
        }
    }

    _showDefaultMessageDisplay() {
        return this._model.gameEditor
            .showDefaultMessageView({
                message: "No results to display"
            })
            .then(() => {
                this._defaultViewActive = true;
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "AuditSummaryView._showDefaultMessageDisplay error");
            });
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor
            .hideDefaultMessageView()
            .then(() => {
                this._defaultViewActive = false;
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "AuditSummaryView._hideDefaultMessageDisplay error");
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        return Promise.resolve()
            .then(() => {
                if (_.isUndefined(this._grid)) {
                    return Promise.resolve();
                } else {
                    return this._grid.shutdown();
                }
            })
            .then(
                () => {
                    this._model = undefined;
                    this._rootElem.remove();
                    this._rootElem = undefined;
                    this._defaultViewActive = undefined;
                    this._grid = undefined;
                    this._gridRows = undefined;
                },
                (err) => {
                    this.model._logger.warn({ error: err }, "AdvisoryViewRenderer.shutdown() error.");
                }
            );
    }

    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                this._grid = new EntityGrid({
                    gridKey: this._model._gridKey,
                    columns: this._model.columnConfig,
                    pagingFeed: this._model._pagingFeed,
                    showHeader: true
                });
                this._registerListeners();

                if (!this._rootElem.hasChildNodes()) {
                    this._rootElem.appendChild(this._grid.renderer.rootElement);

                    this._renderFooter();
                    this._grid.renderer.renderPromise.then(() => {
                        this._grid.renderer._gridBodyContainer.appendChild(this._footerEl);
                        this._setFooterElemGrid();
                    });
                }

                this._onFeedRefreshView();
            })
            .catch((err) => {
                this._logger.warn({ info: err }, "AuditSummaryView.render() warning");
                this._showDefaultMessageDisplay();
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderFooter() {
        const {
            auditCriticalViolationCount,
            auditInfoViolationCount,
            auditMajorViolationCount,
            auditMinorViolationCount,
            auditViolationCount,
            auditRuleCount,
            auditErrorCount
        } = this._model._deviceEntity.properties;

        const footerHtmlString = `<span></span><span class="total-label">Total</span><span>${auditRuleCount}</span>
        <span class="critical">${
            auditCriticalViolationCount === 0
                ? "<base-icon-gl data-icon='common.check'></base-icon-gl>"
                : _.isNumber(auditCriticalViolationCount)
                ? auditCriticalViolationCount
                : "-"
        }</span>
        <span class="major">${
            auditMajorViolationCount === 0
                ? "<base-icon-gl data-icon='common.check'></base-icon-gl>"
                : _.isNumber(auditMajorViolationCount)
                ? auditMajorViolationCount
                : "-"
        }</span>
        <span class="minor">${
            auditMinorViolationCount === 0
                ? "<base-icon-gl data-icon='common.check'></base-icon-gl>"
                : _.isNumber(auditMinorViolationCount)
                ? auditMinorViolationCount
                : "-"
        }</span>
        <span class="info">${
            auditInfoViolationCount === 0
                ? "<base-icon-gl data-icon='common.check'></base-icon-gl>"
                : _.isNumber(auditInfoViolationCount)
                ? auditInfoViolationCount
                : "-"
        }</span>
        <span class="violation">${auditViolationCount}</span>
        <span>${auditErrorCount}</span>
        `;

        if (
            _.isNumber(auditCriticalViolationCount) ||
            _.isNumber(auditMajorViolationCount) ||
            _.isNumber(auditMinorViolationCount) ||
            _.isNumber(auditInfoViolationCount)
        ) {
            this._footerEl.innerHTML = footerHtmlString;
            this._setFooterElemGrid();
        } else {
            this._footerEl.innerHTML = "";
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onGridWidthChange() {
        this._setFooterElemGrid();
    }

    // _onRefreshTotals() {
    //     this._renderFooter();
    // }

    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    _onFeedRefreshView() {
        let totalEntities = this._model._pagingFeed.totalEntities;
        if (totalEntities === 0) {
            if (!this._defaultViewActive) {
                this._showDefaultMessageDisplay();
            }
            this._hideViewActions();
            // this._model.gameEditor.hideViewAction("runAll");
        } else {
            this._showViewActions();
            if (this._defaultViewActive) {
                this._hideDefaultMessageDisplay();
            }
        }
    }

    _onRunAll() {
        this._model._runAll();
    }

    _onDownloadSummary() {
        this._model.gameEditor.disableViewAction("downloadSummary");
        this._model._downloadSummary().finally(() => {
            this._model.gameEditor.enableViewAction("downloadSummary");
        });
    }

    _hideViewActions() {
        this._model.gameEditor.hideViewAction("downloadSummary");
        this._model.gameEditor.hideViewAction("runAll");
    }

    _hideLeftFooterContainer() {}

    _refreshGrid() {}

    _showViewActions() {
        this._model.gameEditor.showViewAction("downloadSummary");
        this._model.gameEditor.showViewAction("runAll");
    }

    _showLeftFooterContainer() {}

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _setFooterElemGrid() {
        const gridHeaderEl = this._grid.renderer.rootElement.querySelector("column-container header-row");
        const gridCols = gridHeaderEl.querySelectorAll("grid-column");

        let gridTemplateCols = "";
        gridCols.forEach((col) => {
            gridTemplateCols += " " + col.style.width;
        });
        this._footerEl.style.gridTemplateColumns = gridTemplateCols;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = AuditSummaryViewRenderer;
